import logoAsset from "@/assets/logo-tama.png.asset.json";

interface BrandLogoProps {
  className?: string;
}

/** Logo officiel TAMA, partagé entre les points d’entrée de l’application. */
const BrandLogo = ({ className = "h-8 w-auto" }: BrandLogoProps) => (
  <img
    src={logoAsset.url}
    alt="TAMA"
    className={className}
    decoding="async"
  />
);

export default BrandLogo;